import _export from '../internals/export.js';
import fails$1 from '../internals/fails.js';
import isObject$1 from '../internals/is-object.js';
import classofRaw from '../internals/classof-raw.js';
import arrayBufferNonExtensible from '../internals/array-buffer-non-extensible.js';

var $ = _export;
var fails = fails$1;
var isObject = isObject$1;
var classof = classofRaw;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible; // eslint-disable-next-line es/no-object-isfrozen -- safe

var $isFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES = fails(function () {
  $isFrozen(1);
}); // `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE
}, {
  isFrozen: function isFrozen(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return true;
    return $isFrozen ? $isFrozen(it) : false;
  }
});
